import { useContext, useMemo, useRef, useState } from 'react';
import { useCurrentRoute } from 'react-navi';
import { AuthContext } from '@repo-level/core-front';
import useEventListener from '@repo-level/core-front/hooks/eventListener';

import { Logo } from 'components/Logo';
import { CommonUtilsContext } from 'contexts/commonUtils';
import { UserWallets } from '../UserWallets';
import { AnalyticsEventName } from 'api/analytics';
import { useAnalytics } from 'helpers/analytics';

import { ScMobileHeader } from './styled';
import { AddonsContext } from 'contexts/addons';

const noHeaderPages = ['search-games'];

export const HeaderMobile = () => {
  const {
    url: { pathname },
  } = useCurrentRoute();

  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } = useContext(
    AddonsContext
  );

  const ref = useRef<HTMLDivElement | null>(null);
  const [isTop, setIsTop] = useState(true);

  const { sendEventToAnalytics } = useAnalytics();

  const { isMobile } = useContext(CommonUtilsContext);
  const { isAuthenticated } = useContext(AuthContext);

  const noHeader = useMemo(
    () => noHeaderPages.includes(pathname.split('/')[1]),
    [pathname]
  );

  useEventListener('scroll', () => setIsTop(window.scrollY <= 20));

  const {
    sendLogoButtonAnalytics,
    sendCurrencySelectAnalytics,
    sendDepositButtonAnalytics,
  } = useMemo(() => {
    return {
      sendLogoButtonAnalytics: () =>
        sendEventToAnalytics({
          name: AnalyticsEventName.HEADER__LOGO__CLICK,
        }),
      sendCurrencySelectAnalytics: () =>
        sendEventToAnalytics({
          name: AnalyticsEventName.HEADER__CURRENCY_SELECT__CLICK,
        }),
      sendDepositButtonAnalytics: () =>
        sendEventToAnalytics({
          name: AnalyticsEventName.HEADER__DEPOSIT_BUTTON__CLICK,
        }),
    };
  }, [sendEventToAnalytics]);

  return !isMobile || noHeader ? null : (
    <ScMobileHeader
      ref={ref}
      isTop={isTop}
      isAuth={isAuthenticated}
      withEmailConfirmationPopup={isEmailConfirmationPopup}
      emailConfirmationPopupHeight={emailConfirmationPopupHeight}
    >
      <Logo
        height={isAuthenticated ? 24 : 32}
        smallLogo={isAuthenticated}
        onClick={sendLogoButtonAnalytics}
      />
      {isAuthenticated && (
        <div className="wallet">
          <UserWallets
            onClickCurrencySelectButton={sendCurrencySelectAnalytics}
            onClickDepositButton={sendDepositButtonAnalytics}
          />
        </div>
      )}
    </ScMobileHeader>
  );
};
